module.exports = __webpack_public_path__ + "static/media/frame_39.ae9f32fd.jpg";